import { gql } from '@apollo/client';

const getUserArticlePoaTimePoints = gql`
  query getUserArticlePoaTimePoints($articleId: String!) {
    getUserArticlePoaTimePoints(articleId: $articleId)
  }
`;

export default getUserArticlePoaTimePoints;
